import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { TokenService } from '../../shared/services/token.service';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { WebsocketService } from "../../services/websocket.service";
import { SwstoragService } from '../../storage/swstorag.service';
import { ModulesApisService } from '../../services/modules-apis.service';
import { DatePipe, Location } from "@angular/common";
import { NavController, Platform, ModalController } from '@ionic/angular';
import { ViewVideoApptWaitingRoomPtPage } from '../../view-video-appt-waiting-room-pt/view-video-appt-waiting-room-pt.page';

import { take } from 'rxjs/operators';
import { IMediaTrack, IRemoteUser, NgxAgoraSdkNgService } from 'ngx-agora-sdk-ng';

import { MediaService } from '../../shared/services/media.service';

import {
  NgxAgoraService,
  Stream,
  AgoraClient,
  ClientEvent,
  StreamEvent,
  AgoraRTC
} from 'ngx-agora';

export interface IMeetingUser {
  type: 'local' | 'remote';
  user?: IRemoteUser;
  mediaTrack?: IMediaTrack;
}

import { Storage } from '@ionic/storage';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SWASTH_CONST } from '../../constant';
const TOKEN_KEY = 'swplus-token';
const helper = new JwtHelperService();

@Component({
  selector: 'app-meeting-preview',
  templateUrl: './meeting-preview.component.html',
  styleUrls: ['./meeting-preview.component.scss']
})
export class MeetingPreviewComponent implements OnInit, OnDestroy {
  mobViewStatus: boolean = false;
  @ViewChild('localVideo', { static: true }) localVideo?: ElementRef;
  link = '';
  channel = '';
  subscriptions: Subscription[] = [];
  userList: IMeetingUser[] = [];
  audioInId = '';
  videoInId = '';
  audioOutId = '';
  token = '';
  mediaTrack?: IMediaTrack;
  pinnedUser?: IMeetingUser | null;

  showSettings = false;
  joinLoading = false;
  newLoading = false;
  connectionInfoForm?: FormGroup;

  ptWaitingRoomList: any = [];
  prescriptionStatus = false;
  prescritpionData: any;
  apptObject: any;
  cameraPreview = true;
  doctorDetail: any;
  patientName: any;
  ptAge: any;
  ptMobile: any;
  ptGender: any;
  remoteVideo = false;
  viewMoreData: any;
  calling = false;

  localCallId = 'agora_local';
  localCallIdCalling = 'agora_local_calling';
  agoraRTC: AgoraRTC;
  client: AgoraClient;
  localStream: Stream;
  uid: string;
  micon = true;
  cameraon = true;

  doctorProfileList: any = [];
  hospProfile: any;
  selectedDocProfile: any;
  decodeTok: any;
  agoraObj: any = {};
  videocallObject; any;
  docProfile: any;
  availableVideoDevice: any;
  avilableCameraDevices: any = [];
  otherCameraDevices: any = [];
  tenantId: any;
  chatData: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private tokeService: TokenService,
    private clipboard: Clipboard,
    private webSocket: WebsocketService,
    private swstorage: SwstoragService,
    private moduleApi: ModulesApisService,
    private datepipe: DatePipe,
    private agoraService: NgxAgoraSdkNgService,
    private mediaService: MediaService,
    private tokenService: TokenService,
    private navCtrl: NavController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private agoraService1: NgxAgoraService,
    private storage: Storage

  ) {
    window.onpopstate = (evt) => {
      //alert("back");
      //this.refuseCall();
      //   this.agoraService.leave();
      // this.mediaTrack?.stop();
      // this.remoteVideo=false;
      // this.cameraPreview=true;
      this.onBackLocalLeave();
    };
    this.uid = "12345";
    let deviceWidth = this.platform.width();
    //alert(deviceWidth);
    if (deviceWidth < 750) {
      this.mobViewStatus = true;
      console.log(this.mobViewStatus);
    } else {
      this.mobViewStatus = false;
    }
    this.platform.resize.subscribe(async () => {
      let deviceWidth = this.platform.width();
      //alert(deviceWidth);
      if (deviceWidth < 750) {
        this.mobViewStatus = true;
        console.log(this.mobViewStatus);
      } else {
        this.mobViewStatus = false;
      }
    });

    this.agoraService.getCameras().then(data => {
      console.log(data);
      this.avilableCameraDevices = data;
      // alert(this.avilableCameraDevices.length);
    });
  }

  ngOnInit(): void {
    this.docProfile = SWASTH_CONST.USER_PROFILE;
    this.tenantId = this.docProfile.tenantID;
    this.agoraService.getDevices().then(data => {
      console.log(data);
      const videoDevices = data.filter(function (device) {
        return device.kind === "videoinput";
      });
      console.log(videoDevices);
      this.availableVideoDevice = videoDevices;
    })



    this.getMessages();
    this.startCall();
    this.chatData = JSON.parse(localStorage.getItem('ctRoom' + this.tenantId));
    console.log("chat Data", this.chatData);
    this.prepareVideoCall(this.chatData.chatRoomDetails);
    // this.prepareVideoCall(data.data);
    this.connectionInfoForm = this.formBuilder.group({
      channel: '',
      link: '',
    });

    const channelChangeSubs = this.connectionInfoForm.get('channel') ?.valueChanges.subscribe(value => {
      if (value === '') {
        this.connectionInfoForm ?.get('link') ?.enable({ emitEvent: false });
      }
      else {
        this.connectionInfoForm ?.get('link') ?.disable({ emitEvent: false });
      }
    });

    this.subscriptions.push(channelChangeSubs as Subscription);

    const linkChangeSubs = this.connectionInfoForm.get('link') ?.valueChanges.subscribe(value => {
      if (value === '') {
        this.connectionInfoForm ?.get('channel') ?.enable({ emitEvent: false });
      }
      else {
        this.connectionInfoForm ?.get('channel') ?.disable({ emitEvent: false });
      }
    });
    this.subscriptions.push(linkChangeSubs as Subscription);

    this.getAuthToken();

  }

  async getAuthToken() {

    console.log(': ', this.storage.get(TOKEN_KEY));
    const token = await this.storage.get(TOKEN_KEY);
    this.token = token;
    if (this.token) {
      this.moduleApi.decodedToken = helper.decodeToken(token);
      this.getDoctorProfilesByMobileno(this.moduleApi.decodedToken.MOBILE);
    }
    else {
      this.getDoctorProfilesByMobileno(this.moduleApi.decodedToken.MOBILE);
    }
  }

  async switchCamera() {
    //alert(this.videoInId);
    this.mediaTrack ?.stop();
    // this.avilableCameraDevices.forEach(otherVideoDevices => {
    //   if(otherVideoDevices.deviceId!=this.videoInId)
    //   {
    //     this.otherCameraDevices.push(otherVideoDevices);
    //   }
    // });
    // alert(this.videoInId);
    // alert(this.avilableCameraDevices.length);
    // alert(this.avilableCameraDevices[1].deviceId);
    this.mediaService.videoInputId = this.avilableCameraDevices[1].deviceId;
    // this.mediaTrack = await this.agoraService.join(this.channel, this.token)
    //   .WithCameraAndMicrophone(this.audioInId, this.avilableCameraDevices[0].deviceId)
    //   .Apply();
    // this.mediaService.selectedVideoInputId.next(this.availableVideoDevice[0].deviceId
    // );
    // alert(this.availableVideoDevice[0].deviceId);

  }

  getDoctorProfilesByMobileno(mobileno) {
    // this.moduleApi.getDocprofilebymobno(mobileno)
    // .subscribe(docData => {
    //   console.log("profile result==",docData);
    //   if(docData.length>0) {
    //     this.doctorProfileList = docData;
    //     this.doctorProfileList[0].userType = this.moduleApi.decodedToken.type;
    //     console.log("dsdssd",this.doctorProfileList[0]);
    //     this.selectedDocProfile = this.doctorProfileList[0].docprofile;
    //     this.doctorDetail=this.selectedDocProfile;
    //     this.getWaitingPtList();

    //   }
    // });
    this.moduleApi.getDocprofilebymobno(mobileno)
      .subscribe((docData: any) => {
        console.log("profile result==", docData);
        if (docData.length > 0) {
          this.doctorProfileList = docData;
          let doctorProfile: any = this.doctorProfileList.filter(
            (data) => data.docprofile.waitingRoomAccess == 'yes'
          );
          console.log("Access Doctor Profile", doctorProfile);
          if (doctorProfile.length > 0) {
            this.docProfile = doctorProfile[0].docprofile;
            console.log("Access Doctor Profile", this.docProfile);
            console.log("dsdssd", this.docProfile);
            this.swstorage.setStorage("USERPROFILE", this.docProfile);
            this.swstorage.setStorage("DOCTORPROFILE", this.docProfile);
            this.selectedDocProfile = this.docProfile;
            //this.docProfile=this.selectedDocProfile;
            this.hospProfile = doctorProfile[0].hosprofile;
            this.doctorDetail = this.selectedDocProfile;
            this.getWaitingPtList();
          }
          //this.doctorProfileList[0].userType = this.moduleApi.decodedToken.type;

        }
      });
  }

  videoCall(data) {
    console.log("Video call status", data);
    this.calling = true;
    setTimeout(() => {
      this.prepareVideoCall(data.data);
    }, 1000);

  }

  async viewMore() {
    let vdata: any = {
      ptList: this.ptWaitingRoomList,
      docDetails: this.doctorDetail
    }
    this.viewMoreData = vdata;
    const modal = await this.modalCtrl.create({
      component: ViewVideoApptWaitingRoomPtPage,
      componentProps: {
        ptWaitingRoomList: this.ptWaitingRoomList,
        docDetails: this.doctorDetail
      },
      backdropDismiss: true,
      animated: true,
    });
    modal.onDidDismiss().then(data => {
      console.log(data);
      if (data.data == "close") {
        this.getWaitingPtList();
      }
      if (data.data.appt != null) {
        this.prepareVideoCall(data.data);
      }
    });
    modal.present();
  }

  getWaitingPtList() {
    this.moduleApi
      .getAllWaitingRoomPt(this.doctorDetail.docUserID, this.doctorDetail.tenantID, new Date().toISOString().split("T")[0])
      .subscribe(data => {
        console.log("data", this.ptWaitingRoomList);
        this.ptWaitingRoomList = data;
        this.ptWaitingRoomList.forEach(ptlist => {
          //console.log(ptlist);
          ptlist.profile.age = this.getAge(ptlist.profile.ptDob);
          this.patientName = ptlist.profile.ptFirstName + " " + ptlist.profile.ptLastName;
          this.ptAge = this.getAge(ptlist.profile.ptDob);
          this.ptMobile = ptlist.profile.ptMobileNo;
          this.ptGender = ptlist.profile.ptGender;
        });
        console.log("data", this.ptWaitingRoomList);
      });

  }

  getCompletedWaitingPtList() {
    this.moduleApi
      .getAllWaitingRoomPt(this.doctorDetail.docUserID, this.doctorDetail.tenantID, new Date().toISOString().split("T")[0])
      .subscribe(data => {
        console.log("data", this.ptWaitingRoomList);
        this.ptWaitingRoomList = data;
        this.ptWaitingRoomList.forEach(ptlist => {
          console.log(ptlist);
          console.log("Websocket call==>", ptlist.profile.userID, this.doctorDetail.docUserID, this.doctorDetail.tenantID);
          // this.webSocket.sendWaitingVideoAppointmentCompletedNotificationToPatient(ptlist.profile.userID,this.doctorDetail.docUserID,this.doctorDetail.tenantID);
          ptlist.profile.age = this.getAge(ptlist.profile.ptDob);
          this.patientName = ptlist.profile.ptFirstName + " " + ptlist.profile.ptLastName;
          this.ptAge = this.getAge(ptlist.profile.ptDob);
          this.ptMobile = ptlist.profile.ptMobileNo;
          this.ptGender = ptlist.profile.ptGender;
        });
        console.log("data", this.ptWaitingRoomList);
      });

  }

  randomChannel(): number {
    let randPatient = Math.floor(Math.random() * 20000000) + 1;
    return randPatient;
  }

  getAge(dob: Date) {
    let latest_date = this.datepipe.transform(Date(), 'yyyy-MM-dd');
    let dobdate = new Date(dob)
    let dobdate1 = new Date(latest_date);
    var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds 
    var timeDiff = Math.round(Math.abs((dobdate1.getTime() - dobdate.getTime()) / (oneDay)));
    var age = (timeDiff / 365);
    let age1 = Math.floor(age);
    return age1;
  }

  openPrescription(pl) {
    console.log("PL Data=>", pl);
    this.prescritpionData = pl;
    this.prescriptionStatus = true;
  }

  closePrescription(ev) {
    this.prescriptionStatus = ev;
  }

  ngOnDestroy(): void {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

  onShowSettings(): void {
    this.showSettings = true;
  }

  onCloseSettings(): void {
    this.showSettings = false;
  }

  onJoinMeeting(channel, pl): void {
    //const { channel, link } = this.connectionInfoForm?.value;
    let apptObject = pl;
    this.videocallObject = pl;
    if (channel) {
      const joinLink = this.tokeService.getLink(channel);
      let meetinglink = location.origin + "/#/meeting?link=" + joinLink;
      console.log(joinLink);

      if (this.channel) {
        this.agoraObj.doctorUserID = apptObject.appt.docUserID;
        this.agoraObj.patientUserID = apptObject.appt.userID;
        this.agoraObj.circleCode = apptObject.appt.tenantID;
        this.agoraObj.doctorRtmToken = "";
        this.agoraObj.doctorRTCToken = "";
        this.agoraObj.patientRTMToken = "";
        this.agoraObj.patientRTCToken = "";
        this.agoraObj.patientUID = "";
        this.agoraObj.doctorUID = "";
        this.agoraObj.createdDateTime = new Date();
        this.agoraObj.channelName = this.channel;
        this.agoraObj.status = "Active";
        this.agoraObj.meetingLink = joinLink;
        console.log("Agora Object==>", this.agoraObj);
        this.moduleApi
          .saveAgoraVideoCallDetails(this.agoraObj)
          .subscribe(data => {
            console.log("Agora Video Details==>", data);
          });
      }

      setTimeout(() => {

        this.webSocket.sendVideoCallNotificationToPatient(apptObject.appt.docUserID, apptObject.appt.userID, apptObject.appt.tenantID, "newwaitingroom", joinLink, channel);
      }, 1000);

    }
    //this.router.navigate(['/meeting'], { queryParams: { channel, link } });

  }

  completeAppt(appt) {
    appt.apptStatus = "completed"
    this.moduleApi
      .savePtVideoWaitingRoom(appt)
      .subscribe(data => {
        console.log("data", data);
        if (data == "Success") {
          this.getCompletedWaitingPtList();
          // this.webSocket.sendWaitingVideoAppointmentCompletedNotificationToPatient(appt.ptUserId,appt.docUserId,appt.tenantID);
        }
      });
  }

  makeVoiceCall(pl) {
    console.log(this.doctorDetail, this.doctorDetail.docMobileno, pl.profile.ptMobileNo);
    this.moduleApi.makeVoiceCall(this.doctorDetail.docMobileno, pl.profile.ptMobileNo)
      .subscribe(voiceCallData => {
        console.log("Voice Call Response==>", voiceCallData);
      });
  }

  prepareVideoCall(pl) {
    this.calling = true;
    console.log("Patient==>", pl);
    this.patientName = pl.ptProfile.ptFirstName + " " + pl.ptProfile.ptLastName;
    // this.channel = "swasthtestcall3456123";
    this.channel = "swasthcircle" + this.randomChannel();
    console.log("Chanel Name", this.channel);


    setTimeout(() => {
      forkJoin([
        //this.activatedRoute.queryParams.pipe(take(1)),
        this.mediaService.selectedAudioInputId.pipe(take(1)),
        this.mediaService.selectedAudioOutputId.pipe(take(1)),
        this.mediaService.selectedVideoInputId.pipe(take(1)),
      ])
        .pipe(
          take(1),
        ).subscribe(([aInId, aOutId, vInId]) => {
          this.link = "";
          if (this.link) {
            const result = this.tokenService.getChannel(this.link);
            if (result.error) {
              alert(result.error);
              this.router.navigate(['/..']);
              return;
            }
            this.channel = result.channel as string;
          }
          this.tokenService.getToken(this.channel, 0);
          this.audioInId = aInId;
          this.videoInId = vInId;
          this.audioOutId = aOutId;
        });

      const tokenSub = this.tokenService.token.pipe(take(1)).subscribe(token => {
        this.token = token;
        this.onJoinMeeting(this.channel, pl);
        this.joinVideo();
      });
      this.subscriptions.push(tokenSub);

      const remoteUserLeaveSubs = this.agoraService.onRemoteUserLeft().subscribe(leftuser => {

        setTimeout(() => {
          this.localStream.stop();
          this.localStream.close();
          this.onLocalLeave();
        }, 1000);

        this.userList = this.userList.filter(user => user.user ?.uid !== leftuser.user.uid);
        if (this.pinnedUser && this.pinnedUser.user ?.uid && this.pinnedUser.user.uid === leftuser.user.uid) {
          this.pinnedUser = null;
        }
      });
      this.subscriptions.push(remoteUserLeaveSubs);

      const remoteUserChangeSubs = this.agoraService.onRemoteUsersStatusChange().subscribe(status => {
        switch (status.connectionState) {
          case 'CONNECTED':
            this.calling = false;
            this.cameraPreview = false;
            this.remoteVideo = true;
            this.localStream.stop();
            this.localStream.close();

            if (!this.userList.find(user => user.user ?.uid === status.user.uid)) {
              //this.userList.push({ type: 'remote', user: status.user });
              status.user.audioTrack ?.setVolume(400);
              this.pinnedUser = { type: 'remote', user: status.user };
            }
            break;
          case 'DISCONNECTED':
          case 'DISCONNECTING':
          case 'RECONNECTING':
            const currentUserIndex = this.userList.findIndex(user => user.user ?.uid === status.user.uid);
            if (currentUserIndex >= 0) {
              this.userList[currentUserIndex] = { type: 'remote', user: status.user };
              if (this.pinnedUser && this.pinnedUser.user ?.uid && this.pinnedUser.user.uid === status.user.uid) {
                status.user.audioTrack ?.setVolume(400);
                this.pinnedUser = { type: 'remote', user: status.user };
              }
            }
            break;
        }
      });
      this.subscriptions.push(remoteUserChangeSubs);

      const localUserJoinedSubs = this.agoraService.onLocalUserJoined().subscribe(track => {
        this.userList.push({ type: 'local', mediaTrack: track.track });
      });
      this.subscriptions.push(localUserJoinedSubs);
      console.log(this.userList);
    }, 3000);

  }
  async joinVideo(): Promise<void> {
    this.mediaTrack = await this.agoraService.join(this.channel, this.token)
      .WithCameraAndMicrophone(this.audioInId, this.videoInId)
      .Apply();
  }

  onLocalMic(value: boolean): void {
    !value ? this.mediaTrack ?.microphoneUnMute() : this.mediaTrack ?.microphoneMute();
  }

  onLocalCamera(value: boolean): void {
    !value ? this.mediaTrack ?.cameraOn() : this.mediaTrack ?.cameraOff();
  }

  onLocalPinned(value: boolean): void {
    const localuser = this.userList.find(user => user.type === 'local');
    if (localuser) {
      this.onPin(localuser);
    }
  }

  onLocalLeave(): void {

    this.moduleApi
      .updateAgoraStatus(this.videocallObject.appt.tenantID, this.videocallObject.appt.docUserID, this.videocallObject.appt.userID, "Deactive")
      .subscribe(data => {
        console.log(data);
      });

    this.agoraService.leave();
    this.mediaTrack ?.stop();
    this.remoteVideo = false;
    this.previewLeave();
    // this.cameraPreview=true;
    // this.startCall();

  }

  onBackLocalLeave() {
    this.moduleApi
      .updateAgoraStatus(this.videocallObject.appt.tenantID, this.videocallObject.appt.docUserID, this.videocallObject.appt.userID, "Deactive")
      .subscribe(data => {
        console.log(data);
      });

    this.agoraService.leave();
    this.mediaTrack ?.stop();
    this.remoteVideo = false;
    this.cameraPreview = true;
    this.previewBackLeave();
    //this.startCall();
  }



  onPin(user: IMeetingUser): void {
    if (user.type === 'local') {
      if (this.pinnedUser && this.pinnedUser ?.type === 'local') {
        this.pinnedUser = null;
        return;
      }
      this.pinnedUser = user;
      return;
    }
    if (this.pinnedUser ?.type === 'local') {
      this.pinnedUser = user;
      return;
    }
    if (this.pinnedUser ?.user ?.uid === user.user ?.uid) {
      this.pinnedUser = null;
    } else {
      this.pinnedUser = user;
    }
  }

  getUnpinnedUsers(): IMeetingUser[] {
    if (this.pinnedUser ?.type === 'local') {
      return this.userList.filter(user => user.type !== 'local');
    }
    return this.userList.filter(user => user.user ?.uid !== this.pinnedUser ?.user ?.uid);
  }

  getMessages() {
    // this.webSocket.waitingVideoapptBooking.subscribe((data) => {
    //   if (data) {
    //     console.log("Plus Video Appt Data==>", data);
    //     this.getWaitingPtList();
    //   }

    // });
  }
  previewLeave() {
    this.localStream.stop();
    this.localStream.close();
    this.navCtrl.back();
  }
  previewBackLeave() {
    this.localStream.stop();
    this.localStream.close();
  }
  endCall() {
    this.calling = false;
    this.previewLeave();
  }
  startCall() {
    //this.assignClientHandlers();
    // Added in this step to initialize the local A/V stream
    this.localStream = this.agoraService1.createStream({
      streamID: this.uid,
      audio: true,
      video: true,
      screen: false,
    });
    this.assignLocalStreamHandlers();
    // Join and publish methods added in this step
    this.initLocalStream(() =>
      this.join(
        (uid) => this.publish(),
        (error) => console.error(error)
      )
    );
  }

  join(
    onSuccess?: (uid: number | string) => void,
    onFailure?: (error: Error) => void
  ): void {
    //this.client.join(this.rtcToken, this.channelName, this.uid, onSuccess, onFailure);
  }

  publish(): void {
    let error = false
    this.client.publish(this.localStream, (err) => {
      error == true;
      console.log('Publish local stream error: ' + err)
    }
    );
    if (error == false) {

    }
  }

  private assignLocalStreamHandlers(): void {
    this.localStream.on(StreamEvent.MediaAccessAllowed, () => {
      console.log('accessAllowed');
    });

    // The user has denied access to the camera and mic.
    this.localStream.on(StreamEvent.MediaAccessDenied, () => {
      console.log('accessDenied');
    });
  }

  private initLocalStream(onSuccess?: () => any): void {
    this.localStream.init(
      () => {
        // The user has granted access to the camera and mic.
        this.localStream.play('agora_local');
        if (onSuccess) {
          onSuccess();
        }
      },
      (err) => console.error('getUserMedia failed', err)
    );
  }

  ionViewWillEnter() {
    this.getAuthToken();
  }

  muteMicrophone() {
    console.log("Mute");
    this.localStream.muteAudio();
    this.micon = false;
    this.onLocalMic(false);
  }

  unmuteMicrophone() {
    console.log("Unmute");
    this.localStream.unmuteAudio();
    this.micon = true;
    this.onLocalMic(true);
  }

  muteVideo() {
    console.log("Mute Video");
    this.localStream.muteVideo();
    this.cameraon = false;
    this.onLocalCamera(false);
  }

  unmuteVideo() {
    console.log("Unmute Video");
    this.localStream.unmuteVideo();
    this.cameraon = true;
    this.onLocalCamera(true);
  }


}
